import React from 'react';
import { Container, Text, GridItem } from '@chakra-ui/react';

import { DeptGrid } from '@rsc/ui-components/dept/design-system';
import ReviewCard from '@rsc/ui-components/dept/atoms/ReviewCard';

interface Props {
  block: {
    headline: string;
    reviews?: {
      _key: string;
      title: string;
      body: string;
      author: string;
      location: string;
      image: object;
      product: object;
    }[];
  };
}

export default function CardRowReviews({ block }: Readonly<Props>) {
  if (!block) return null;
  const { headline, reviews } = block;
  const reviewFilter = reviews.filter(
    review =>
      review?.product?.productReference?.shopifyProduct?.variants?.[0]?.sku &&
      review?.product?.productReference?.store?.slug?.current
  );
  if (!reviewFilter?.length) return null;
  return (
    <Container as="section" py={20}>
      {headline && (
        <Text as="h2" textStyle="h2" pb={10}>
          {headline}
        </Text>
      )}
      <DeptGrid>
        {reviewFilter?.map(review => (
          <GridItem key={review._key} colSpan={{ base: 6, md: 3, lg: 4 }}>
            <ReviewCard
              {...review}
              product={{
                sku: review?.product?.productReference?.shopifyProduct
                  ?.variants[0]?.sku,
                href: review?.product?.productReference?.store?.slug?.current,
              }}
            />
          </GridItem>
        ))}
      </DeptGrid>
    </Container>
  );
}
